import React from "react";
import { Spinner } from "react-bootstrap";

import { useOrganizationContext } from "../../../../../contexts/organizations/organizationsContext";
import { useUser } from "../../../../../contexts/userContext";
import { useResetPassword } from "../../../../../hooks/reactQueryHooks/useUsers";

const Security: React.FC = () => {
  const { user } = useUser();
  const { currentOrganization } = useOrganizationContext();

  const { refetch, isLoading } = useResetPassword(
    user?.sub || "",
    currentOrganization?.id || "",
  );

  return (
    <>
      {user?.providers?.includes("Touchcast") ? (
        <div className="card">
          <div
            className="card-header border-0 cursor-pointer"
            role="button"
            data-bs-toggle="collapse"
            data-bs-target="#kt_account_signin_method"
          >
            <div className="card-title m-0">
              <h3 className="fw-bolder m-0">Security settings</h3>
            </div>
          </div>

          <div id="kt_account_signin_method" className="collapse show">
            <div className="card-body border-top p-9">
              <div className="d-flex flex-wrap align-items-center mb-10">
                <div id="kt_signin_password">
                  <div className="fs-6 fw-bolder mb-1">Password</div>
                  <div className="fw-bold text-gray-600">************</div>
                </div>

                <div id="kt_signin_password_button" className="ms-auto">
                  <button
                    className="btn btn-primary"
                    onClick={() => refetch()}
                    disabled={isLoading}
                  >
                    Reset password
                    {isLoading && (
                      <Spinner
                        className="ms-2"
                        size="sm"
                        animation="border"
                        data-testid="value-loader"
                      />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export { Security };
